import React from "react";
import { landingContentBySlug } from "../config/landing";
import CoachConnectPage from "./pages/CoachConnectPage/CoachConnectPage";
import InsightsReportsPage from "./pages/InsightsReportsPage/InsightsReportsPage";
import LionsPridePage from "./pages/LionsPridePage/LionsPridePage";
import ServiceLinePage from "./pages/ServiceLinePage/ServiceLinePage";
import SoarPage from "./pages/SoarPage/SoarPage";
import UspsTrademarksPage from "./pages/UspsTrademarksPage/UspsTrademarksPage";

/**
 * Designed product landing pages, keyed by `CatalogProduct.landingPageKey`.
 *
 * These are marketing's pages from the CertainPath Design System, ported to
 * React one component per product (copy and links live in the page file,
 * edited via PR). They replace the older template-driven pages in
 * `config/landing` key by key; a key present here wins over the same key
 * there.
 */
export const designedLandingPages: Record<string, React.ComponentType> = {
  "coach-connect": CoachConnectPage,
  "insights-reports": InsightsReportsPage,
  "lions-pride": LionsPridePage,
  "service-line": ServiceLinePage,
  soar: SoarPage,
  "usps-trademarks": UspsTrademarksPage,
};

/** Every key a catalog product can point at: designed pages plus the older template pages. */
export const landingPageKeys: string[] = Array.from(
  new Set([
    ...Object.keys(designedLandingPages),
    ...Object.keys(landingContentBySlug),
  ]),
).sort();

/** Whether a catalog product's key resolves to a page, so its card can link there. */
export function hasLandingPage(key: string | null | undefined): boolean {
  return !!key && (key in designedLandingPages || key in landingContentBySlug);
}
